import { render, staticRenderFns } from "./Guanyuwomen.vue?vue&type=template&id=52a86c3f&scoped=true"
import script from "./Guanyuwomen.vue?vue&type=script&lang=js"
export * from "./Guanyuwomen.vue?vue&type=script&lang=js"
import style0 from "./Guanyuwomen.vue?vue&type=style&index=0&id=52a86c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a86c3f",
  null
  
)

export default component.exports